import { Space } from "antd";
import { AiOutlineCloudUpload } from "react-icons/ai";

const AttachFileButton = () => {
  return (
    <Space style={{ fontSize: 15 }}>
      Chứng từ đính kèm
      <AiOutlineCloudUpload size={24} />
      (word, excel, pdf, jpg,...)
    </Space>
  );
};

export default AttachFileButton;
